import * as yup from "yup";

export const passwordFieldSchema = yup.object().shape({
  password: yup.string().required("請輸入密碼").min(6, "請輸入最少6位字符密碼"),
});
